import TicketRepositoryInterface, {
  TicketReviewFormDataInterface, TicketReviewInterface,
  TicketInterface, CronFilterInterface, CreateCronFilterInterface,
} from '@/services/QC-V2/ticket/interfaces';
import { AxiosInstance } from 'axios';
import { FilterRequestData } from '@/services/QC-V2/chat/interfaces';

export default class TicketRepository implements TicketRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  public async getTicketQueue(filterRequestData?: FilterRequestData): Promise<[TicketInterface[], number]> {
    const url = `/ticket-controller-v2/tickets/queue?${this.createQueryString(filterRequestData)}`;
    const response = await this.axios.get(url);

    return response.data;
  }

  public async getTicketArchive(filterRequestData?: FilterRequestData): Promise<[TicketInterface[], number]> {
    const url = `/ticket-controller-v2/tickets/archive?${this.createQueryString(filterRequestData)}`;
    const response = await this.axios.get(url);

    return response.data;
  }

  public async getTicketById(id: number): Promise<TicketInterface> {
    const response = await this.axios.get(`/ticket-controller-v2/tickets/${id}`);

    return response.data;
  }

  public async reviewTicket(reviews: TicketReviewFormDataInterface[]): Promise<void> {
    const response = await this.axios.post('/ticket-controller-v2/reviews', reviews);

    return response.data;
  }

  public async softDeleteReview(id: number): Promise<void> {
    await this.axios.delete(`/ticket-controller-v2/reviews/${id}`);
  }

  public async getCronFilters(): Promise<CronFilterInterface[]> {
    const response = await this.axios.get('ticket-controller-v2/cron-config');

    return response.data;
  }

  public async createCronFilter(data: CreateCronFilterInterface): Promise<CronFilterInterface[]> {
    const response = await this.axios.post('ticket-controller-v2/cron-config', data);

    return response.data;
  }

  public async getFilterById(id: number): Promise<CronFilterInterface> {
    const response = await this.axios.get(`ticket-controller-v2/cron-config/${id}`);

    return response.data;
  }

  public async updateCronFilter(id: number, data: CreateCronFilterInterface): Promise<void> {
    const response = await this.axios.patch(`ticket-controller-v2/cron-config/${id}`, data);

    return response.data;
  }

  public async deleteCronFilter(id: number): Promise<void> {
    await this.axios.delete(`ticket-controller-v2/cron-config/${id}`);
  }

  private createQueryString(filterRequestData?: FilterRequestData): string {
    if (!filterRequestData) {
      return '';
    }

    const parameters = Object.keys(filterRequestData)
      .filter((key) => !!filterRequestData[key])
      .map((key) => `${key}=${filterRequestData[key]}`);

    return parameters.join('&');
  }
}
